import getCookie from './utils/getCookie';
import setCookie, { defaultExpiration } from './utils/setCookie';

function autoDetectLocation() {
  const baseUrl = window.headerFooterData?.baseUrl;
  if (!baseUrl) {
    // headerFooterData not yet initialized (streaming SSR timing) — retry on load
    if (document.readyState !== 'complete') {
      window.addEventListener('load', autoDetectLocation, { once: true });
    }
    return;
  }

  const rawCookie = getCookie('iabbb_user_location');
  if (rawCookie) {
    return;
  }

  fetch(`${baseUrl}/api/geoip/`)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`GeoIP failed (status: ${res.status})`);
      }
      return res.json();
    })
    .then(({ location, geoIpInfo }) => {
      const postalCode = location?.postalCode || geoIpInfo?.postalCode;
      if (!postalCode || !location?.city || !location?.state) {
        return;
      }

      const locationId = location.id || `${location.city}_${location.state}_${location.threeLetterIsoCountryCode}`;

      setCookie('iabbb_user_location', locationId, defaultExpiration);
      setCookie('iabbb_user_postalcode', postalCode, defaultExpiration);
      if (location.latLng?.lat != null && location.latLng?.lng != null) {
        setCookie('iabbb_user_latlng', `${location.latLng.lat},${location.latLng.lng}`, defaultExpiration);
      }

      if (location.bbbInfo?.bbbId) {
        setCookie('iabbb_user_bbb', location.bbbInfo.bbbId, defaultExpiration);

        window.headerFooterData = {
          ...(window.headerFooterData || {}),
          bbb: {
            name: location.bbbInfo.bbbName,
            url: location.bbbInfo.urls?.bbbUrl,
          },
        };
      }

      document.dispatchEvent(
        new CustomEvent('iabbb:localeselector.setlocation', {
          bubbles: true,
          detail: {
            id: location.id,
            city: location.city,
            state: location.state,
            country: location.country,
            postalCode,
            latLng: location.latLng,
            bbbInfo: location.bbbInfo
              ? {
                  bbbId: location.bbbInfo.bbbId,
                  bbbName: location.bbbInfo.bbbName,
                  primaryCountry: location.bbbInfo.primaryCountry,
                  primaryLanguage: location.bbbInfo.primaryLanguage,
                }
              : null,
          },
        }),
      );
    })
    .catch((err) => {
      // biome-ignore lint/suspicious/noConsole: for Sentry to suck up
      console.warn('[initGeoLocation] auto-detect failed:', err);
    });
}

autoDetectLocation();
